"use client";

import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import LogAnalytics from "@/components/LogAnalytics";
import {usePathname} from "next/navigation";

export default function Firebase({ children }) {
    const pathname = usePathname();
    return (
        <>
            <LogAnalytics eventName={"page_view"} eventParams={{page : pathname, page_title:pathname}} />
            {children}
        </>
    )
}